import {
    useCopyVkOrdApiKey,
    useDeleteVkOrdKey,
    useMutationVkOrdKey,
} from '@/shared/api'
import { CopyTextIcon, TrashIcon } from '@/shared/assets'
import { useCopyToClipboard } from '@/shared/hooks'
import {
    Button,
    CheckIcon,
    ContentContainer,
    Input,
    ShadcnButton,
    Toast,
} from '@/shared/ui'
import { VkOrdApiKeyResponse } from '@synapex/shared2/gateway-rest-api'
import { CheckIcon as CheckLucideIcon, XIcon } from 'lucide-react'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { workspaceMethods } from '@synapex/shared2/entities'
import { useActiveWorkspace } from '@/true-fsd/data/advertiser-account/hooks'

type ORDUserApiProps = {
    ordData: VkOrdApiKeyResponse | undefined | null
}

export const ORDUserApi: React.FC<ORDUserApiProps> = ({ ordData }) => {
    const { copy, toastVisible, toastMessage, hideToast } = useCopyToClipboard()

    const [selectedToDelete, setSelectedToDelete] = useState(false)

    const [value, setValue] = useState('')

    const { activeWorkspace } = useActiveWorkspace()
    const activeWd = workspaceMethods.getWd(activeWorkspace)

    const { mutate: setUserVkOrdKey, error } = useMutationVkOrdKey()
    const { mutate: deleteUserVkOrdKey } = useDeleteVkOrdKey()
    const { mutateAsync: copyVkOrdApiKey } = useCopyVkOrdApiKey()

    function handleRemoveVkOrdApiKey() {
        setSelectedToDelete(false)

        deleteUserVkOrdKey(activeWd)
    }

    async function handleCopyVkOrdApiKey() {
        const apiKey = await copyVkOrdApiKey(activeWd)
        copy(apiKey)
    }

    useEffect(() => {
        setValue(ordData?.vkOrdApiKey || '')
    }, [ordData?.vkOrdApiKey])

    useEffect(() => {
        if (!error) {
            return
        }
        console.error('error', error)
        toast.error('api ключ невалидный')
    }, [error])

    async function handleSave() {
        setUserVkOrdKey({
            ...activeWd,
            vkOrdApiKey: value,
        })
    }

    return (
        <>
            <ContentContainer>
                <div className="flex items-center gap-[10px] pb-3">
                    <h2 className="text-lg font-extrabold">Интеграция с ОРД</h2>
                    <CheckIcon
                        checked={!!ordData?.vkOrdApiKey}
                        className="h-4 w-4"
                    />
                </div>

                <p className="pb-[14px] text-[12px]">
                    Сервис поддерживает только VK ОРД
                </p>
                <div className="flex gap-[10px] pb-3">
                    {selectedToDelete ? (
                        <div className="flex h-[32px] w-full max-w-[328px] items-center justify-end gap-2 rounded-lg border border-stroke p-2">
                            <span className="text-[13px]">Удалить?</span>
                            <div className="flex items-center">
                                <div
                                    onClick={handleRemoveVkOrdApiKey}
                                    className="cursor-pointer text-blue-primary"
                                >
                                    <CheckLucideIcon className="h-4 w-4" />
                                </div>
                                <div
                                    onClick={() => setSelectedToDelete(false)}
                                    className="cursor-pointer"
                                >
                                    <XIcon className="h-4 w-4" />
                                </div>
                            </div>
                        </div>
                    ) : (
                        <Input
                            error={!!error}
                            type="password"
                            shouldShowClearButton={false}
                            value={value}
                            disabled={!!ordData?.vkOrdApiKey}
                            onChange={setValue}
                            className="w-full max-w-[328px]"
                            innerClassName="h-[32px]"
                            placeholder="Введите API ключ VK ОРД РР"
                        />
                    )}
                    {!!ordData?.vkOrdApiKey && !selectedToDelete && (
                        <div className="flex items-center gap-2">
                            <ShadcnButton
                                className="h-auto p-0"
                                onClick={handleCopyVkOrdApiKey}
                            >
                                <img
                                    src={CopyTextIcon}
                                    className="h-4 w-[14px]"
                                />
                            </ShadcnButton>
                            <ShadcnButton
                                className="h-auto p-0"
                                onClick={() => setSelectedToDelete(true)}
                            >
                                <img src={TrashIcon} />
                            </ShadcnButton>
                        </div>
                    )}
                </div>

                <Button
                    className="m-0 px-8 py-4"
                    onClick={handleSave}
                    disabled={!!ordData?.vkOrdApiKey}
                >
                    Сохранить
                </Button>
            </ContentContainer>

            <Toast
                message={toastMessage}
                visible={toastVisible}
                onClose={hideToast}
                greenSwooshIcon={true}
            />
        </>
    )
}
